function Hero({ onCtaClick }) {
  return (
    <section className="text-center py-12 md:py-16">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        What Should You Eat Right Now?
      </h1>
      <p className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
        Pick your mood and get instant food ideas.
        <br />
        No overthinking. Just food that fits how you feel.
      </p>
      <button
        onClick={onCtaClick}
        className="bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition shadow-sm"
      >
        Choose Your Mood
      </button>
    </section>
  );
}

export default Hero;
